import React from 'react';
import Reveal from '../../../shared/Reveal/Reveal';
import { useSolutionsWhoWeWorkWithContent } from '../../../../hooks/useSolutionsWhoWeWorkWithContent';
import './WhoWeWorkWith.css';

const WhoWeWorkWith = () => {
  const { content, isLoading } = useSolutionsWhoWeWorkWithContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, clients } = content;

  return (
    <section className="who-we-work">
      <div className="who-we-work__inner">
        <Reveal>
          <h2 className="who-we-work__title">{title}</h2>
        </Reveal>

        <Reveal className="who-we-work__panel" delay={80}>
          {clients.map(({ title: clientTitle, description }) => (
            <article key={clientTitle} className="who-we-work__cell">
              <h3 className="who-we-work__cell-title">{clientTitle}</h3>
              <p className="who-we-work__cell-text">{description}</p>
            </article>
          ))}
        </Reveal>
      </div>
    </section>
  );
};

export default WhoWeWorkWith;
